export default "__VITE_ASSET__BtCnLsmA__"